module.exports = __webpack_public_path__ + "img/cases-brand-vive-lazyload-01.ca17b7cd.jpg";